import PageProtectedLayout from "../../../components/Page/PageProtectedLayout";
import Feedback from "./Feedback";
import { useTranslation } from "../../../language";

export default function FeedbackWelcome() {
  const { t } = useTranslation();

  return (
    <PageProtectedLayout
      headline={t("page_hl_feedback")}
      specify={t("page_sp_feedback")}
    >
      <Feedback />
    </PageProtectedLayout>
  );
}
